import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useFirebaseLogin } from "@/app/hooks/api_hooks/auth/useFirebaseLogin";
import { ILogoutModalProps } from "../interface";

import { useRouter } from "@/app/hooks/useRouter";
import { useUpdateMirrorStateAPI } from "@/app/hooks/api_hooks/Cart/useUpdateMirrorStateAPI";

const LogoutModal: React.FC<ILogoutModalProps> = () => {
  const { clientSignOut } = useFirebaseLogin();
  const { getRouteKey } = useRouter();
  const { execute: updateMirrorState } = useUpdateMirrorStateAPI();

  const handelClick = async () => {
    localStorage.setItem("VMS_LOGOUT_EVENT", Date.now().toString());
    await updateMirrorState({ screen: "idle", cart_id: null, status: "LOGGED_OUT" });

    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `/app/login`;
  };

  return (
    <ModalPrompt
      modalId="LOGOUT"
      button={{
        primaryButtonText: "Logout",
        secondaryButtonText: "No",
        primaryCallback: () => {
          clientSignOut();
          handelClick();
          window.open(getRouteKey("LOGIN_PAGE", "url"), "_self");
        },
        shouldHideOnClick: true,
      }}
      title="Are you sure ?"
      content={<span className="text-xs">You will be logged out from VMS.</span>}
    />
  );
};

export default LogoutModal;
